export enum PredicateNodeType {
  Operator,
  Operand
}

export enum PredicateNodeBinaryOperators {
  StartBracket,
  CloseBracket,
  Equals,
  NotEqual,
  GreaterThan,
  GreaterThanEqual,
  LessThan,
  LessThanEqual,
  And,
  Or,
  Not
}

export enum PredicateNodeOperandSubtype {
  Constant,
  Variable
}
